import { render } from "./DataUsagesMaster.vue?vue&type=template&id=78415d62&scoped=true"
import script from "./DataUsagesMaster.vue?vue&type=script&lang=js"
export * from "./DataUsagesMaster.vue?vue&type=script&lang=js"

import "./DataUsagesMaster.vue?vue&type=style&index=0&id=78415d62&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78415d62"]])

export default __exports__